import { createMutation } from "react-query-kit";

import { getApi } from "@api/apiPath";
import { axiosClient, queryClient } from "@api/clients.ts";

import type { MutationFunction } from "@tanstack/react-query";

import type { IDeleteApiEntities } from "@api/apiPath";

export const createDeleteFunc = <
  TResponse,
  TPathParams extends object | undefined,
>(
  path: IDeleteApiEntities,
) => {
  interface IVariables {
    pathParam: TPathParams;
  }

  const { key, getPath } = getApi(`${path}.delete`);

  const deleteFunc: MutationFunction<TResponse, IVariables> = ({
    pathParam,
  }) => {
    return axiosClient.delete(getPath(pathParam as never));
  };

  return { deleteFunc, key };
};

export const createDeleteHook = <TResponse, TVariables>(
  deleteFunc: MutationFunction<TResponse, TVariables>,
  path: IDeleteApiEntities,
) => {
  const useDelete = createMutation<TResponse, TVariables>({
    mutationFn: deleteFunc,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [`${path}.getAll`],
      });
      queryClient.invalidateQueries({
        queryKey: [`infinite.${path}.getAll`],
      });
    },
  });

  return { useDelete };
};

export const createDeleteApi = <
  TResponse,
  TPathParams extends object | undefined,
>(
  path: IDeleteApiEntities,
) => {
  const { deleteFunc } = createDeleteFunc<TResponse, TPathParams>(path);
  const { useDelete } = createDeleteHook(deleteFunc, path);

  return { deleteFunc, useDelete };
};
